// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__pd0BR","col":"styles_col__QhAkI"};